var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"worklog-container"},[_c('work-log',{attrs:{"issues":_vm.issues,"embedded":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }